<script>
import {mapState} from 'vuex'
import Chief from './Chief'
import MoralPersonSearch from '../moralPersons/MoralPersonSearch'
import PhysicalPersonSearch from '../physicalPersons/PhysicalPersonSearch'
import PhysicalPersonCreate from '../physicalPersons/PhysicalPersonCreate'
import PhysicalPersonEdit from '../physicalPersons/PhysicalPersonEdit'
import MoralPersonCreate from '../moralPersons/MoralPersonCreate'
import MoralPersonEdit from '../moralPersons/MoralPersonEdit'
import PappersChief from './PappersChief'
import Auditors from '../auditors/Auditors'
import CacMandateSwitches from './CacMandateSwitches'
import ChiefMandateSwitches from './ChiefMandateSwitches'
import loading from '../../../../common/components/loading'
import ToastHandler from '../../../../common/mixins/ToastHandler.vue'
import governanceTypeOptions from '../../../../common/data/governanceTypeOptions.json'

export default {
    name: 'Chiefs',

    components: {
        Auditors,
        CacMandateSwitches,
        ChiefMandateSwitches,
        PappersChief,
        MoralPersonSearch,
        MoralPersonCreate,
        MoralPersonEdit,
        PhysicalPersonSearch,
        PhysicalPersonCreate,
        PhysicalPersonEdit,
        Chief,
    },

    mixins: [ToastHandler],

    props: {
        clientData: {},
        fullVue: null,
        section: {
            type: String,
            default: 'both',
            validator: (value) => ['both', 'chiefs', 'auditors'].includes(value),
        },
    },

    data() {
        return {
            loading: false,
            governanceTypeOptions,
        }
    },

    async created() {
        this.$store.commit('legalVM/SET_CLIENT', this.clientData)
        this.$store.commit('legalVM/RESET_STATUS')
        if (this.clientData?.id) {
            await this.$store.dispatch('legalVM/getClientData', this.clientData.id)
        }
    },

    methods: {
        update() {
            if (this.fullVue) {
                this.$emit('update-company')
            } else {
                location.reload()
            }
        },

        showSearch(type) {
            this.$store.commit('legalVM/SET_PERSON_TYPE', type)
            this.$store.commit('legalVM/SET_LINK_TYPE', 'chiefs')
            this.$store.commit('legalVM/SHOW_SEARCH')
        },

        showEdit() {
            this.$store.commit('legalVM/SET_LINK_TYPE', 'chiefs')
            this.$store.commit('legalVM/SHOW_EDIT')
        },

        resetKey() {
            this.key = Date.now()
        },

        async updatePappers() {
            console.log('pappers update')
            this.loading = true
            this.pappers = {}
            try {
                await axios.put(
                    `/moralPersons/${this.client.main_moral_person_id}/pappers`
                )
                await this.$store.dispatch(
                    'legalVM/getClientData',
                    this.client.id
                )
                this.loading = false
                this.resetKey()
            } catch (error) {
                console.error(error)
            }
        },

        async updateGovernanceType() {
            this.showRecordingToast()
            try {
                const response = await axios.put(
                    `/legal/clients/${this.client.id}/legal-extended-data`,
                    {
                        governance_type: this.client.governance_type,
                    }
                )
                this.$store.commit('legalVM/SET_CLIENT', response.data.data)
                this.handleSuccess('Type de gérance enregistré')
            } catch (error) {
                this.handleErrors(error?.response?.status)
            }
        },
    },

    computed: {
        ...mapState({
            client: (state) => state.legalVM.client,
            editing: (state) => state.legalVM.editing,
            searching: (state) => state.legalVM.searching,
            creating: (state) => state.legalVM.creating,
            personType: (state) => state.legalVM.personType,
            linkType: (state) => state.legalVM.linkType,
        }),

        chiefs() {
            return this.client.chiefs === null || this.client.chiefs === undefined
                ? null
                : this.client.chiefs.data
        },

        noChief() {
            return this.chiefs === null || (this.chiefs.length === 0 && !this.searching && !this.editing)
        },

        pappersChiefs() {
            return this.client.pappers_data.chiefs
        },

        noPappersChief() {
            return (
                this.pappersChiefs.length === 0 &&
                !this.searching &&
                !this.editing
            )
        },

        showGovernanceType() {
            return ['EURL', 'SARL'].includes(this.client?.legal_form)
        },

        showChiefsSection() {
            return this.section === 'both' || this.section === 'chiefs'
        },

        showAuditorsSection() {
            return this.section === 'both' || this.section === 'auditors'
        },
    },
}
</script>
<template>
    <div>
        <div v-if="showChiefsSection && !creating && !editing">
            <template v-if="showGovernanceType">
                <h4>Type de gérance</h4>
                <b-row class="mb-3">
                    <b-col sm="3">
                        <b-form-select
                            v-model="client.governance_type"
                            :options="governanceTypeOptions"
                            size="sm"
                            @change="updateGovernanceType"
                        />
                    </b-col>
                </b-row>
            </template>
            <h4>Liste des dirigeant·e·s</h4>

<!--            <p v-if="!noChief">type: {{ linkType }}</p>-->
            <b-alert :show="noChief" variant="primary">
                Aucun·e dirigeant·e n'a été saisi·e pour cette société
            </b-alert>

            <div>
                <chief
                    v-for="chief in chiefs"
                    :key="'chief' + chief.id"
                    :item="chief"
                    :can-edit="true"
                    @chief-is-deleted="update"
                />
            </div>

            <b-button
                v-if="!searching && !editing && !creating"
                variant="primary"
                size="sm"
                @click="showSearch('physical')"
            >
                <i class="fas fa-plus fa-fw"></i> Ajouter une personne physique
            </b-button>
            <b-button
                v-if="!searching && !editing && !creating"
                variant="primary"
                size="sm"
                @click="showSearch('moral')"
            >
                <i class="fas fa-plus fa-fw"></i> Ajouter une personne morale
            </b-button>

            <chief-mandate-switches />
        </div>

        <div v-if="showChiefsSection && personType === 'moral' && linkType==='chiefs'">
            <moral-person-search v-if="searching"/>
            <moral-person-create v-if="creating"/>
            <moral-person-edit v-if="editing"/>
        </div>

        <div v-if="showChiefsSection && personType === 'physical' && linkType==='chiefs'">
            <physical-person-search v-if="searching"/>
            <physical-person-create v-if="creating" :person-type="'chiefs'"/>
            <physical-person-edit v-if="editing"/>
        </div>

        <hr
            v-if="showChiefsSection && showAuditorsSection && !creating && !editing"
            class="my-4"
        />

        <auditors
            v-if="showAuditorsSection"
            :client-data="clientData"
            :full-vue="fullVue"
            embedded
            @update-company="update"
        />

        <cac-mandate-switches
            v-if="showAuditorsSection && !creating && !editing"
        />
    </div>
</template>


<style scoped></style>
